/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Stop_Labels_Style_With_BackgroundInputs */

const fr_settings_stop_labels_style_with_background = /** @type {(inputs: Settings_Stop_Labels_Style_With_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avec fond`)
};

const en_settings_stop_labels_style_with_background = /** @type {(inputs: Settings_Stop_Labels_Style_With_BackgroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With background`)
};

/**
* | output |
* | --- |
* | "With background" |
*
* @param {Settings_Stop_Labels_Style_With_BackgroundInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_stop_labels_style_with_background = /** @type {((inputs?: Settings_Stop_Labels_Style_With_BackgroundInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Stop_Labels_Style_With_BackgroundInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_stop_labels_style_with_background(inputs)
	return en_settings_stop_labels_style_with_background(inputs)
});